import React, { useEffect, useRef } from "react";
import { Box, Stack } from "@mui/joy";
import { theme } from "styles/theme";
import CustomTypography from "components/common/CustomTypography";
import { useNavigate } from "react-router-dom";
import { BottomNextButtonTmp } from "../../../../components/common/BottomNextButtonTmp";
import useMixpanelPromotion from "../../../../hooks/useMixpanelPromotion";

export default function Demographic_1_Promotion() {
  const navigate = useNavigate();

  const trackPromotion = useMixpanelPromotion({
    eventName: "다음 버튼 클릭",
    params: {
      type: "demographic",
      pageId: "1",
    },
  });

  // TODO 리팩토링
  const handleNext = () => {
    trackPromotion();

    navigate(`/promotion-onboarding/demographic/2`);
  };

  const pageKey = "demographic_1";

  function useEffectOnce(callback: () => void) {
    const ref = useRef(false);

    useEffect(() => {
      if (ref.current) return;
      ref.current = true;

      if (typeof callback === "function") {
        callback();
      }
    }, []);
  }

  useEffectOnce(() => {});

  return (
    <Box
      sx={{
        // (헤더 높이를 뺀 나머지 높이에 맞추고 싶다면 적절히 계산하여 넣으면 됩니다)
        display: "flex",
        flexDirection: "column",
        minHeight: "calc(var(--vh,1vh) * 100 - 255px)", // TODO 경험치
      }}
    >
      <Box
        sx={{
          flex: 1, // 상단 헤더와 하단 버튼 사이 남은 공간 전부 사용
          display: "flex",
          flexDirection: "column",
          justifyContent: "center", // 세로 가운데 정렬
        }}
      >
        <Stack spacing={2}>
          <CustomTypography
            variant="Subtitle"
            fontWeight={700}
            sx={{
              color: theme.vars.palette.Content.Highlight,
            }}
          >
            지금부터 맞춤 프로그램을 구성합니다.
          </CustomTypography>
          <CustomTypography
            variant="Subtitle"
            fontWeight={500}
            sx={{
              color: theme.vars.palette.Content.Strong,
            }}
          >
            디스턴싱 프로그램은 개인의 특성과 성향, 주변 상황을 다각도로
            고려하여 짜여집니다.
          </CustomTypography>
          <CustomTypography
            variant="Subtitle"
            fontWeight={500}
            sx={{
              color: theme.vars.palette.Content.Strong,
            }}
          >
            이 작은 첫 시작이 수많은 사람들의 인생을 완전히 바꿔 놓았다는 점을
            기억해주세요.
          </CustomTypography>
        </Stack>
      </Box>
      <BottomNextButtonTmp
        disabled={false}
        onClick={handleNext}
        text={"다음"}
      />
    </Box>
  );
}
